import { Injectable } from '@angular/core';
import { HttpClient} from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AddressLookupService {

  constructor(private http: HttpClient) { }

  private apiUrl = 'https://iqenergy-dev.quidossoftware.co.uk';

  getAddressList(countryCode: string, postcode: string): Observable<any> {
    const url = `${this.apiUrl}/restful/wap/address/list/DOM/${postcode}?country=${countryCode}`;
    return this.http.get<any>(url);
  }

  getFullAddress(countryCode: string, tempId: string): Observable<any> {
    const url = `${this.apiUrl}/restful/wap/address/get/DOM/${countryCode}/${tempId}`;
    return this.http.get<any>(url);
  }
}
